<template>
  <div class="vm-create-basic">
    <span class="sub-title">{{ $t('global.informations') }}</span>
    <Input
      label="forms.vm.name"
      id="name"
      v-model="form.name"
      :state="validateState('name')"
    />

    <span class="sub-title">{{ $t('global.features') }}</span>

    <b-form-group
      :label="$t('forms.vm.vmImage')"
      :state="validateState('vmImage')"
    >
      <multiselect
        v-model="form.vmImage"
        :options="vmImageList"
        track-by="id"
        label="name"
        :custom-label="customVMImageLabel"
        :loading="loadingVMImage"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        @search-change="getVmImages"
        :placeholder="$t('forms.vm.vmImage')"
        :show-no-results="true"
        :disabled="dcNode.id == ''"
      />

      <a
        href="javascript:;"
        class="select-from-link"
        :disabled="dcNode.id == ''"
        @click="openSecondModalImageList"
        >{{ $t('global.selectFromList') }}</a
      >
    </b-form-group>

    <b-form-group
      :label="$t('forms.vm.catalog')"
      :state="validateState('catalog')"
    >
      <multiselect
        v-model="form.catalog"
        :options="catalogList"
        track-by="id"
        label="name"
        @select="selectedCatalogEvent"
        :custom-label="customCatalogLabel"
        :loading="loadingCatalog"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('forms.vm.catalog')"
        :show-no-results="true"
        :disabled="dcNode.id == ''"
      />

      <a
        href="javascript:;"
        class="select-from-link"
        :disabled="dcNode.id == ''"
        @click="openSecondModal"
        >{{ $t('global.selectFromList') }}</a
      >
    </b-form-group>

    <b-form-group
      :label="$t('forms.vm.network')"
      :state="validateState('network')"
    >
      <multiselect
        v-model="form.network"
        :options="networkList"
        track-by="id"
        label="name"
        :loading="loadingNetwork"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        @search-change="getNetworks"
        :limit="3"
        :placeholder="$t('forms.vm.network')"
        :show-no-results="false"
        :disabled="dcNode.id == ''"
      />
    </b-form-group>

    <SecondModal
      :title="secondModalTitle"
      :show="showSecondModal"
      @closeSecondModal="closeSecondModal()"
    >
      <ProductCatalog
        v-if="secondModalType == 'productCatalog'"
        :productId="findProductId"
        @selectedItem="selectedProductCatalog"
        @closeSecondModal="closeSecondModal()"
      />

      <VMImages
        v-if="secondModalType == 'vmImages'"
        :dcNodeId="dcNode.id"
        @selectedItem="selectedVMImages"
        @closeSecondModal="closeSecondModal()"
      />
    </SecondModal>

    <ProductCatalogPriceInfo
      v-if="selectedCatalog"
      :selectedCatalog="selectedCatalog"
      :selectedCatalogDayCount="selectedCatalogDayCount"
    ></ProductCatalogPriceInfo>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'VMCreateBasic',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    dcNode: Array | String,
  },
  data() {
    return {
      form: {
        name: '',
        vmImage: '',
        catalog: '',
        network: '',
      },
      findProductId: '',
      selectedCatalog: '',
      selectedCatalogDayCount: '30',
      vmImageList: [],
      catalogList: [],
      networkList: [],
      loading: false,
      loadingVMImage: false,
      loadingCatalog: false,
      loadingNetwork: false,
      showSecondModal: false,
      secondModalTitle: '',
      secondModalType: '',
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
      vmImage: {
        required,
      },
      catalog: {
        required,
      },
      network: {
        required,
      },
    },
  },
  created() {
    this.dcNodeChange()
  },
  methods: {
    // VM Image begin
    getVmImages(search) {
      this.loadingVMImage = true

      if (search != '') {
        this.vmImageList = []
      }

      this.getVmImageList(search)
        .then((res) => {
          this.setVmImageList(res)
          this.loadingVMImage = false
        })
        .catch(() => {
          this.vmImageList = []
          this.loadingVMImage = false
        })
    },
    getVmImageList(search) {
      this.loadingVMImage = true
      return new Promise((resolve, reject) => {
        let query = `repo/images?datacenterNode=${this.dcNode.id}&position=id|desc`
        // let query = `repo/images?position=id|desc&showLatestOnly=1&repo_server=${this.dcNode.repo_server_id}`

        console.log(this.dcNode)
        if (search && search != '') {
          query += `&name=${search}`
        }

        ApiService.get(query)
          .then(({ data }) => {
            resolve(data)
            this.loadingVMImage = false
          })
          .catch((err) => {
            reject(err)
            this.loadingVMImage = false
          })
      })
    },
    setVmImageList(res) {
      if (res && res.data && res.data.length > 0) {
        this.vmImageList = res.data
      }
    },
    // VM Image end
    // Product catalog begin
    getProductCatalogs() {
      this.findProductId = this.dcNode.product_id

      if (this.findProductId) {
        this.getProductCatalogList(this.findProductId)
          .then((res) => {
            this.setProductCatalogList(res)
          })
          .catch(() => {
            this.catalogList = []
          })
      } else this.catalogList = []
    },
    getProductCatalogList(findProductId) {
      this.loadingCatalog = true
      return new Promise((resolve, reject) => {
        ApiService.get(
          `marketplace/${findProductId}/catalogs?page=1&start=0&limit=25&position=id|desc`
        )
          .then(({ data }) => {
            resolve(data)
            this.loadingCatalog = false
          })
          .catch((err) => {
            reject(err)
            this.loadingCatalog = false
          })
      })
    },
    setProductCatalogList(res) {
      if (res && res.data && res.data.length > 0) {
        this.catalogList = res.data
      }
    },
    // Product catalog end
    // Network begin
    getNetworks(search) {
      this.loadingNetwork = true

      if (search != '') {
        this.networkList = []
      }

      this.getNetworkList(search)
        .then((res) => {
          this.setNetworkList(res)
          this.loadingNetwork = false
        })
        .catch(() => {
          this.loadingNetwork = false
          this.networkList = []
        })
    },
    getNetworkList(search) {
      this.loadingNetwork = true
      return new Promise((resolve, reject) => {
        let query = `iaas/networks/overview?datacenterNode=${this.dcNode.id}&position=id|desc`

        if (search && search != '') {
          query += `&name=${search}`
        }

        ApiService.get(query)
          .then(({ data }) => {
            resolve(data)
            this.loadingNetwork = false
          })
          .catch((err) => {
            reject(err)
            this.loadingNetwork = false
          })
      })
    },
    setNetworkList(res) {
      if (res && res.data && res.data.length > 0) {
        this.networkList = res.data
      }
    },
    // Network end

    dcNodeChange() {
      this.vmImageList = []
      this.catalogList = []
      this.networkList = []
      this.form.vmImage = ''
      this.form.catalog = ''
      this.form.network = ''
      this.selectedCatalog = ''
      this.selectedCatalogDayCount = '30'

      if (this.dcNode && this.dcNode.id != '') {
        this.getVmImages()
        this.getProductCatalogs()
        this.getNetworks('')
      }
    },
    customVMImageLabel(item) {
      return this.$customFunctions.upperFirstLetter(
        `${item.os ? item.os + ' ' : ''}${
          item.distro ? item.distro + ' ' : ''
        }${item.version ? item.version + ' ' : ''}${
          item.cpu_type ? item.cpu_type + ' ' : ''
        }`
      )
    },
    customCatalogLabel(item) {
      let newName = item.name

      if (item.args) {
        newName += ' ('
        if (item.args.cpu) newName += `${item.args.cpu} CPU, `
        if (item.args.ram)
          newName += `${this.$customFunctions.convertMBtoGB(
            item.args.ram
          )} GB RAM, `
        if (item.args.disk)
          newName += `${this.$customFunctions.convertMBtoGBWithHalfPoint(
            item.args.disk
          )} GB DISK`
        newName += ')'
      }

      return newName
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        server_name: this.form.name,
        datacenter_node_id: this.dcNode.id,
        virtual_machine_image_id: this.form.vmImage.id,
        product_catalog_id: this.form.catalog.id,
        network_id: this.form.network.id,
      }

      ApiService.post(`iaas/virtual-machines/wizards/create`, params)
        .then(({ data }) => {
          setTimeout(() => {
            this.$generateToast(
              this,
              'success',
              this.$t('global.createVirtualMachineSuccessful')
            )
          }, 100)
          this.$emit('startCreatedControl', true, data, params.server_name)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
    selectedProductCatalog(item, selectedDayCount) {
      this.form.catalog = item
      this.selectedCatalog = item
      this.selectedCatalogDayCount = selectedDayCount
    },
    selectedVMImages(item) {
      this.form.vmImage = item
    },
    openSecondModal() {
      this.secondModalTitle = 'global.selectProductCatalogList'
      this.secondModalType = 'productCatalog'
      this.showSecondModal = true
    },
    openSecondModalImageList() {
      this.secondModalTitle = 'forms.vm.vmImage'
      this.secondModalType = 'vmImages'
      this.showSecondModal = true
    },
    closeSecondModal() {
      this.secondModalTitle = ''
      this.secondModalType = ''
      this.showSecondModal = false
    },
    selectedCatalogEvent(selectedDropdownCatalog) {
      this.selectedCatalog = selectedDropdownCatalog
    },
  },
  components: {
    ProductCatalog: () => import('@/components/ProductCatalog'),
    ProductCatalogPriceInfo: () =>
      import('@/components/ProductCatalogPriceInfo'),
    VMImages: () =>
      import('@/components/compute/virtualMachines/modals/VMImages'),
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
    dcNode: function () {
      this.dcNodeChange()
    },
  },
}
</script>

<style lang="scss" scoped>
.vm-create-basic {
  .sub-title {
    display: inline-block;
    font-size: 13px;
    line-height: 19px;
    font-weight: bold;
    color: #6c7293;
    margin-bottom: 20px;
  }

  .select-from-link {
    font-size: 12px;
    line-height: 18px;
    text-decoration-line: underline;
    color: #00baf2;
  }
}
</style>
